import { useCallback } from 'react';

export function useVideoPlayback(videoRef) {
  const handleSeek = useCallback((seconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime = seconds;
    }
  }, [videoRef]);

  return { handleSeek };
}